// test1304
(1304 && 0);
